export default __webpack_public_path__ + "static/media/user-image.c3f94521.png";